import { buildCrudRoutes } from 'Arch/components/crud/CrudRouter';

const featureBreadcrumb = [
  {
    text: 'Dashboard',
    disabled: false,
    to: 'dashboard',
  },
  {
    text: 'Administradores',
    disabled: false,
    to: 'administrator.list',
  },
];

export default [
  ...buildCrudRoutes({
    basePath: 'administrator',
    baseName: 'administrator',
    baseBreadcrumbs: featureBreadcrumb,
    listRoute: {
      btnText: 'Adicionar Administrador',
      navigateBackRoute: 'dashboard',
      newRouteName: 'administrator.new',
      pageContent: () => import('App/administrators/AdministratorsCrudList.vue'),
      pageTitle: 'Administradores',
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar administradores', searchAttribute: 'search' },
    },
    newRoute: {
      component: () => import('App/administrators/AdministratorsForm.vue'),
      breadcrumbs: [
        {
          text: 'Adicionar administrador',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('App/administrators/AdministratorsForm.vue'),
      breadcrumbs: [
        {
          text: 'Editar administrador',
          disabled: true,
        },
      ],
    },
  }),
];
